import gql from 'graphql-tag';

import type { SavedTalkingPoint, TextAnnotation } from 'src/data/annotation';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CreateTalkingPoints($customerId: ID!, $talkingPoints: [TalkingPointInput!]!) {
    createTalkingPoints(customerId: $customerId, talkingPoints: $talkingPoints) {
      id
      name
      score
    }
  }
`;

export const createTalkingPoints = async ({
  customerId,
  talkingPoints,
}: {
  customerId: ID;
  talkingPoints: TextAnnotation[];
}): Promise<SavedTalkingPoint[]> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, talkingPoints },
  });
  return getSingleProp(result.data) || [];
};
